import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Navbar.css";
import { useAuth } from "context/auth/authcontext";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleNavigation = (path: any) => {
    setIsOpen(false);
    navigate(path);
  };

  return (
    <nav className="navbar">
      {/* Logo */}
      <div
        className="styles.logo"
        onClick={() => handleNavigation("/main/dashboard")}
      >
        <img
          src="https://notifygridmedia.s3.us-east-2.amazonaws.com/black+R+transparent.png"
          className="logo-img"
          alt="rolonium labs logo"
        />
      </div>

      {/* Links */}
      <div className={`links ${isOpen ? "open" : ""}`}>
        <button onClick={() => handleNavigation("/main/dashboard")}>
          Dashboard
        </button>
        <button onClick={() => handleNavigation("/main/properties")}>
          Properties
        </button>
        <button onClick={() => handleNavigation("/main/tenant-payments")}>
          Rent Management
        </button>
        <button onClick={() => handleNavigation("/main/tenant-management")}>
          Tenant Management
        </button>
        <button onClick={() => handleNavigation("/main/finance-dashboard")}>
          Finance Dashboard
        </button>
        {/* <button onClick={() => handleNavigation("/main/documents")}>
          Documents
        </button> */}
        <button onClick={() => logout()}>Log Out</button>
      </div>

      {/* Hamburger Icon */}
      <div className="hamburger" onClick={() => setIsOpen(!isOpen)}>
        <span className={`bar ${isOpen ? "open" : ""}`}></span>
        <span className={`bar ${isOpen ? "open" : ""}`}></span>
        <span className={`bar ${isOpen ? "open" : ""}`}></span>
      </div>
    </nav>
  );
};

export default Navbar;
